interface CheckboxProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export default function Checkbox({
  label,
  checked = false,
  onChange,
  disabled = false,
  className = "",
}: CheckboxProps) {
  const baseClasses = `w-5 h-5 rounded-full border transition-all duration-300 flex items-center justify-center cursor-pointer ${className}`;

  // Circular style with diagonal line when checked (transparent background)
  const primaryClasses = checked
    ? "bg-transparent border-white text-white"
    : "bg-transparent border-gray-600 hover:border-white";

  const disabledClasses =
    "opacity-50 cursor-not-allowed pointer-events-none grayscale";

  const containerClasses = `flex items-center gap-2 group ${
    disabled ? "opacity-50 pointer-events-none" : ""
  }`;

  return (
    <label className={containerClasses}>
      <div className="relative flex items-center justify-center">
        <input
          type="checkbox"
          className="sr-only"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <div
          className={`${baseClasses} ${
            disabled ? disabledClasses : primaryClasses
          }`}
        >
          {checked && (
            <svg
              className="w-5 h-5 text-white absolute -top-1.5 right-0 overflow-visible pointer-events-none"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <line x1="7" y1="23" x2="23" y2="7" />
            </svg>
          )}
        </div>
      </div>
      {label && (
        <span className="text-gray-400 group-hover:text-white text-sm font-medium select-none transition-colors">
          {label}
        </span>
      )}
    </label>
  );
}
